import React from 'react';

import { AlertRootProps as ChakraAlertRootProps, AlertTitleProps } from '@chakra-ui/react';

import { IconProps } from '@nocowanie/icons';

export interface AlertProps extends ChakraAlertRootProps {
    title?: string;
    hideIcon?: boolean;
    titleProps?: AlertTitleProps;
    customIcon?: IconProps;
    buttons?: React.ReactNode[];
    children?: React.ReactNode;
}
